import { useTour } from '@reactour/tour';
import { useMutation } from '@tanstack/react-query';

import { Checkbox } from '@/components/form/checkbox';
import { updateBatch } from '@/features/single-measurement/services/batches';
import {
  IBatch,
  NonDisabledReadyStates,
  State,
} from '@/features/single-measurement/types';

export const GraphAnalysisList = ({
  batches,
  onListUpdate,
  onDemoListUpdate,
}: {
  batches?: IBatch[];
  onListUpdate: () => void;
  onDemoListUpdate?: (id?: string, state?: State) => void;
}) => {
  const { isOpen } = useTour();

  const updateBatchMutation = useMutation({
    mutationFn: ({ id, batch }: { id: string; batch: Partial<IBatch> }) =>
      updateBatch(id, { ...batch }),
    onSettled: () => {
      onListUpdate();
    },
  });

  const handleOnChange = (batch: IBatch) => {
    // toggle the state
    const state = NonDisabledReadyStates.includes(batch.state)
      ? State.ResultReadyDisabled
      : State.ResultReady;

    if (isOpen && onDemoListUpdate) {
      onDemoListUpdate(batch.id, state);
    } else {
      updateBatchMutation.mutate({ id: batch.id, batch: { state } });
    }
  };

  const renderAnalysis =
    batches &&
    batches.map((batch) => (
      <div key={batch.id} className="min-w-max">
        <Checkbox
          value={batch.id}
          label={batch.name ? batch.name : batch.id.substring(0, 10)}
          checked={NonDisabledReadyStates.includes(batch.state)}
          onChange={() => handleOnChange(batch)}
        />
      </div>
    ));

  return (
    <div className="flex flex-col gap-6">
      <h2 className="text-lg font-bold text-black-dark">Use analysis in chart</h2>
      <div className="flex gap-12 py-2 overflow-x-auto cursor-pointer">
        {renderAnalysis}
      </div>
    </div>
  );
};
